<div class="breadcrumb-list" *ngIf="breadcrumbItems?.length > 0" #breadcrumbParent>
  <ul #breadcrumblist>
    <ng-container *ngFor="let item of breadcrumbItems; let counter = index; let isLast = last">
      <li>
        <a class="d-flex align-items-center" (click)="item?.icon != 'pi pi-ellipsis-h' && takeAction(item)">
          <span *ngIf="item?.icon">
            <i
              (click)="item?.icon == 'pi pi-ellipsis-h' && ellipsisfolder.toggle($event)"
              class="text-dark"
              [ngClass]="{ 'mr-2': item?.label?.length > 0 }"
              [class]="item?.icon"></i>
          </span>
          <span *ngIf="item?.icon != 'pi pi-ellipsis-h'" [ngClass]="{ 'bread-color': isLast }">{{ item?.label }}</span>
        </a>
      </li>
      <li class="icon pi pi-chevron-right" *ngIf="counter + 1 < breadcrumbItems?.length"></li>
    </ng-container>
  </ul>
</div>
<p-menu #ellipsisfolder [popup]="true" [model]="collapseItems"></p-menu>
